export * from './MoneyCurrencyRubleIcon';
export * from './MoneyCurrencyRubleIcon16Light';
export * from './MoneyCurrencyRubleIcon16Regular';
export * from './MoneyCurrencyRubleIcon16Solid';
export * from './MoneyCurrencyRubleIcon20Light';
export * from './MoneyCurrencyRubleIcon20Regular';
export * from './MoneyCurrencyRubleIcon20Solid';
export * from './MoneyCurrencyRubleIcon24Regular';
export * from './MoneyCurrencyRubleIcon24Solid';
export * from './MoneyCurrencyRubleIcon32Regular';
export * from './MoneyCurrencyRubleIcon64Regular';
